<template>
  <div class="parent-master-div">
      <div class="main-menu">
        <div class="links-div">
        <router-link 
            class="link" 
            :class="{'active-page':$route.name==='AdminHome'}"
            to="/admin">
            Почетна Страна
        </router-link>
        <router-link 
            class="link" 
            :class="{'active-page':$route.name==='AdminCreateProject'}"
            to="/admin/novi-projekat">
            Нови Пројекат
        </router-link>
        <router-link 
            class="link" 
            :class="{'active-page':$route.name==='AdminActiveProjects'}"
            to="/admin/projekti">
            Активни Пројекти
        </router-link>
        <router-link class="link"
            :class="{'active-page':$route.name==='AdminAllUsersView'}" 
            to="/admin/udruzenja">
            Листа Удружења
        </router-link>
        <router-link class="link" 
        :class="{'active-page':$route.name==='AdminArchivedProjects'}" 
        to="/admin/arhiva">
            Архива
        </router-link>
        </div>
        <div class="main-buttons">
            <span @click="passChangePopupToggle">Промени Лозинку</span>
            <span @click="logOut">Одјави се</span>
        </div>
      </div>
      <div>
        <router-view/>
      </div>

      <pass-change-popup-comp
        v-if="passChangePopup"
        @close="passChangePopupToggle">
      </pass-change-popup-comp>
  </div>
</template>

<script>
import PassChangePopupComp from '@/components/PassChangePopupComp'
import axios from 'axios'

export default {
    components:{
        PassChangePopupComp
    },
    data(){
        return {
            passChangePopup: false
        }
    },
    methods:{
        passChangePopupToggle(){
            this.passChangePopup=!this.passChangePopup
        },
        logOut(){
            axios.get("https://125k122.e2.mars-hosting.com/API/login",{
                params:{
                    sid: sessionStorage.getItem("sid")
                }
            }).then(()=>{
                // console.log(res);
                sessionStorage.removeItem("sid");
                sessionStorage.removeItem("admin");
                this.$router.push("/");
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .main-menu{
        background-color: $primaryColor;
        @include MainMenu();
    }

    @media only screen and (max-width: 1000px) {
        .main-menu{
            flex-direction: column;
            font-size: 0.9rem;
            padding: 15px 0;
            .link{
                &:first-of-type{
                    border-radius: 5px 5px 0 0 ;
                }
                &:last-of-type{
                    border-radius: 0 0 5px 5px;
                }
            }
        }
        .links-div{
            flex-direction: column;
            margin: 20px 0;
            width: 70%;
            >.link{
                margin: 0;
                flex-basis: 100%;
            }
        }
        .main-buttons{
            margin: 20px auto;
            >span{
                margin: 0;
            }
        }
    }
</style>